export default __webpack_public_path__ + "static/media/janisJoplin.dcc1c523.jpeg";